import { endOfDay, format } from 'date-fns'

import { Location } from '@/features/location'
import { CartStoreSlices, SelectedRoom } from '@/stores/cart-store/slices/types'

export const hotelSelectionEvent = (selectedHotel: Location, promoCode?: string) => ({
	event: 'hotelSelection',
	vPageURL: '/booking-engine/rooms-and-rates-2/',
	vPageTitle: 'Booking Engine - Room, Rate and Service selection',
	hotelCode: selectedHotel.hotelCode,
	hotelName: selectedHotel.title,
	coupon: promoCode,
})

const getTotalPrice = (rooms: SelectedRoom[]) =>
	rooms.reduce((total, room) => {
		const totalServiceCost = room.room.services.reduce(
			(prev, curr) => prev + (curr.price?.amountAfterTax ?? 0),
			0
		)
		return total + room.room.rate.price.amountAfterTax + totalServiceCost
	}, 0)

export const offerSelectionEvent = (room: SelectedRoom, cartStore: CartStoreSlices) => ({
	event: 'offerSelection',
	vPageURL: '/booking-engine/rooms-and-rates-2/',
	vPageTitle: 'Booking Engine - Room, Rate and Service selection',
	dateFrom:
		cartStore.travelPeriod.startDate &&
		format(endOfDay(cartStore.travelPeriod.startDate), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
	dateTo:
		cartStore.travelPeriod.endDate &&
		format(endOfDay(cartStore.travelPeriod.endDate), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
	hotelCode: cartStore.location?.hotelCode,
	hotelName: cartStore.location?.title,
	roomCode: room.room.roomTypeCode,
	rateCode: room.room.rate?.ratePlanCode,
	transactionNights: cartStore.travelPeriod.nights,
	transactionRooms: cartStore.roomSelection.selectedRooms.length,
	transactionAdults: cartStore.roomConfigurations.find(
		(config) => config.id === room.roomConfigId
	)?.adults,
	coupon: cartStore.promotion.code,
	totalValue: getTotalPrice(cartStore.roomSelection.selectedRooms).toFixed(2),
})
